export default __webpack_public_path__ + "static/media/ngo-gif4.b99aea5c.gif";